import { render, staticRenderFns } from "./RcpyPD_Client.vue?vue&type=template&id=3c80b85c"
import script from "./RcpyPD_Client.vue?vue&type=script&lang=js"
export * from "./RcpyPD_Client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports